// extracted by mini-css-extract-plugin
export default {"StepperNarrow":"PortfolioModelsManagement_StepperNarrow__B01FT"};